import conf from 'config';

export const getCompanyLogo = (entitiyName) =>
  `${conf.baseUrl}/${conf.baseAPI}/logos/${entitiyName}.png`;
